import { Pipe, PipeTransform } from '@angular/core';

import {IntegrationTaskMap} from '@app/views/admin/application-settings/models/integration-task-map.model';
import {DataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';
import {DomainOfUniquenessProperty} from '@app/views/admin/application-settings/models/domain-of-uniqueness-property.model';

@Pipe({
    name: 'getAvailableAttributesForMergingRules'
})
export class GetAvailableAttributesForMergingRulesPipe implements PipeTransform {

    transform(taskMapping: IntegrationTaskMap[],
        availableAttributes: DataAttribute[],
        currentPropertyName: string,
        selectedMergingRuleProperty: DomainOfUniquenessProperty
    ): any {

        let result: DataAttribute[];
        const currentProperty = taskMapping.find((mapping: IntegrationTaskMap) => mapping.targetPropertyName === currentPropertyName);
        availableAttributes = availableAttributes.filter((attr: DataAttribute) => !attr.isDeniedNotAllowedForFilterRules);
        if (currentProperty) {
            result = availableAttributes.concat([currentProperty.targetProperty]);
        } else {
            result = availableAttributes;
        }

        if (selectedMergingRuleProperty) {
            let selectedMergingRulePropertyIsPresent: boolean;
            if (result && (result.length > 0)) {
                selectedMergingRulePropertyIsPresent = !!result
                    .find((attr: DataAttribute) => attr.propertyName === selectedMergingRuleProperty.propertyName);
            }

            if ((result.length === 0)
                || !result
                || (selectedMergingRuleProperty.propertyName && !selectedMergingRulePropertyIsPresent)) {
                result = [new DataAttribute(selectedMergingRuleProperty.propertyName, selectedMergingRuleProperty.friendlyName)];
            }
        }

        return result;
    }

}
